module.exports = __webpack_public_path__ + "img/Header_Slide_3_720@2x.534a6ec8.png";